import React from "react";
import MuiDialogTitle from '@material-ui/core/DialogTitle';

export default function DialogTitle(props){
    const {...rest} =props;
    return (<MuiDialogTitle {...rest}/>)
}
